import React, { memo } from 'react'
import Link from 'next/link'

export const ColumnSideNavBox = memo(
  ({ label, children }: { label: string; children: React.ReactNode }) => {
    return (
      <div>
        <h3
          className={
            'text-2xl font-bold leading-normal border-b-2 border-[#E7DBCC]'
          }
        >
          {label}
        </h3>
        {children}
      </div>
    )
  }
)

ColumnSideNavBox.displayName = 'ColumnSideNavBox'
